// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-fix-tab":"FixTab_outdoor-recreation-fix-tab__SR_yg"};